import { render, staticRenderFns } from "./SimpleCardsGrid.vue?vue&type=template&id=5eda1fed&scoped=true"
import script from "./SimpleCardsGrid.vue?vue&type=script&lang=js"
export * from "./SimpleCardsGrid.vue?vue&type=script&lang=js"
import style0 from "./SimpleCardsGrid.vue?vue&type=style&index=0&id=5eda1fed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda1fed",
  null
  
)

export default component.exports